export const APPOINTMENT_STRINGS = {
    TEST_ID: "appointment-card",
    CALENDAR_LABEL: "calendar",
    DEFAULT_TITLE: "Appointment with {targetUser}",
    NO_TITLE: "No Title",
    NO_TIME_SPECIFIED: "No Time Specified",
    NO_LOCATION: "No Location",
    STATUS_REQUESTED: "Appointment Requested",
    STATUS_DENIED: "Appointment Declined",
    STATUS_ACCEPTED: "Appointment Accepted",
    STATUS_CANCELED_SENDER: "Appointment Canceled",
    STATUS_CANCELED_RECIPIENT: "Appointment Canceled",
    STATUS_EXPIRED: "Appointment Expired",
    DATE_FORMAT_OPTIONS: { weekday: 'long', month: 'long', day: 'numeric' },
    DATE_LOCALE: 'en-US',
    TIME_SEPARATOR: " – ",
    MINUTES_SUFFIX: " minutes",
    HOURS_SUFFIX: " hr",
    MINUTES_SHORT_SUFFIX: " min",
};
export const TIMEZONE_ABBREVIATION_OVERRIDES = {
  'Asia/Kolkata': 'IST',
  'Asia/Calcutta': 'IST',
  'Asia/Colombo': 'IST',
  'Asia/Tokyo': 'JST',
  'Asia/Shanghai': 'CST',
  'Asia/Hong_Kong': 'HKT',
  'Asia/Singapore': 'SGT',
  'Asia/Dubai': 'GST',
  'Asia/Karachi': 'PKT',
  'Asia/Dhaka': 'BST',
  'Europe/Moscow': 'MSK',
  'Australia/Sydney': 'AEDT',
  'Pacific/Auckland': 'NZDT',
};

// Query param the website's My Schedule adds to the chat URL (appointment = Stream message ID)
export const APPOINTMENT_LINK_PARAM = 'appointmentId';
